import { FormArray, FormBuilder, FormGroup,Validators } from "@angular/forms";
import { UserLocaleDTO } from "src/app/models/UserDetails/userLocaleDTO";

export function buildDetailedDescription(
  locales: UserLocaleDTO[],
  fb: FormBuilder,
  form: FormGroup,
  param: string
) {
  const detailedDescriptionFormArray = form.get(param) as FormArray;
  locales.forEach((locale) => {
    const detailedDescriptionFormGroup = fb.group({ [locale.code]: [null, Validators.maxLength(100)] });
    detailedDescriptionFormArray.push(detailedDescriptionFormGroup);
  });
}

export function populateDetailedDescription(formArray: FormArray, entityFieldObj: object) {
  const detailedDescriptionFormArrayWithValues = createDetailedDescriptionFormGroup(formArray, entityFieldObj);
  formArray.setValue(detailedDescriptionFormArrayWithValues);
}

function createDetailedDescriptionFormGroup(formArray: FormArray, entityFieldObj: object) {
  let arrayWithValues = [];
  for (const localeDesc in entityFieldObj) {
    if (formArray.value.find((locale) => Object.keys(locale)[0] === localeDesc)) {
      arrayWithValues = [
        ...arrayWithValues,
        { [localeDesc]: entityFieldObj[localeDesc] },
      ];
    }
  }

  const arraysJoined = formArray.value.concat(arrayWithValues);
  const finalArrWithValues = arraysJoined.reduce((acc, cur) => {
    const [curLocale] = Object.keys(cur);
    const found = acc.find((localeDesc) => {
      const [localeKey] = Object.keys(localeDesc);
      return localeKey === curLocale;
    });
    if (found) {
      const [curValue] = Object.values(cur);
      found[curLocale] = curValue;
      return [...acc];
    }
    return [...acc, cur];
  }, []);

  return finalArrWithValues;
}

export function setFormAfterDialogClosed(
  locale: string,
  form: FormGroup,
  dialogFormParam: string,
  baseFormParam: string
) {
  const detailedDescriptionArr = form.controls[dialogFormParam].value;
  const found = detailedDescriptionArr.find((localeDesc) => {
    const [localeKey] = Object.keys(localeDesc);
    return localeKey === locale;
  });
  form.controls[baseFormParam].setValue(found[locale]);
}

export function setDetailedDescription(
  form: FormGroup, 
  formParamDetailed: string, 
  formParamDesc?: string, 
  locale?: string
) {
  const detailedDescriptionArr = form.controls[formParamDetailed].value;
  const descriptionStr = form.controls[formParamDesc].value;
  return detailedDescriptionArr.reduce((acc, cur) => {
    const [entries] = Object.entries(cur);
    if (entries[0] === locale) {
      return { ...acc, [entries[0]]: descriptionStr };
    }
    return { ...acc, [entries[0]]: entries[1] };
  }, {});
}
